import Coke from '../assets/coke.webp'
import Sprite from '../assets/sprite.webp'
import Water from '../assets/water.webp'
import ComingSoon from '../assets/coming-soon.webp'
import Brisket from '../assets/brisket.webp'
import BrisketBurntEnds from '../assets/brisketBurntEnds.webp'
import Tritip from '../assets/platedTritip.webp'
import PulledPork from '../assets/pulledPork.webp'
import PulledPorkBirria from '../assets/pulledPorkBirria.webp'
import PorkBelly from '../assets/porkBelly.webp'
import ChickenBreast from '../assets/chickenBreast.webp'
import FiletMignon from '../assets/filetMignon.webp'
import Tzatziki from '../assets/tzatziki.webp'
import CabbageSalad from '../assets/cabbageSalad.webp'
import Hummus from '../assets/hummus.webp'
import Rice from '../assets/rice.webp'
import SutDolma from '../assets/veganDolma.webp'
import MedetteraneanDish from '../assets/medetteraneanVeggiesAndChickpeas.webp'
import StuffedMushrooms from '../assets/stuffedMushrooms.webp'
import StuffedJalapenos from '../assets/stuffedJalapenos.webp'
import PickledOnion from '../assets/pickledOnions.webp'

//  pricing: {
//       taco: 5,
//       burrito: 15,
//       plate: 34,
//       HalfPlate: 22,
//       aLaCarte: 30
//     },

export enum ItemIds {
  Tritip = 0,
  Brisket,
  BrisketBurntEnds,
  PulledPork,
  PulledPorkBirria,
  FiletMignon,
  RancheroFilet,
  ChickenBreast,
  PorkBelly,
  BeefLula,
  TritipChili,
  SutDolma,
  MedetteraneanDish,
  Tzatziki,
  CabageSalad,
  Rice,
  Hummus,
  StuffedMushrooms,
  StuffedJalapenos,
  PickledOnion,
}

export enum ItemType {
  Grilled = 0,
  Smoked,
  Side,
  VeganEntree,
  Other
}

export type Item = {
  id: ItemIds,
  image: string,
  title: string,
  description: string,
  isVegan: boolean,
  pricePerPerson: number,
  nutritionFacts: NutritionFacts,
  type: ItemType,
  pricing?: Pricing
}

export enum OrderType {
  Taco = 0,
  Burrito,
  Plate,
  HalfPlate,
  ALaCarte
}
export interface NutritionFacts {
  calories : number,
  totalFat : number,
  saturatedFat : number,
  transfat: number,
  polyUnsaturatedFat: number,
  monoUnsaturatedFat: number,
  cholesterol : number,  
  sodium: number,
  totalCarbs : number,
  dietaryFiber: number,
  sugar: number,
  protein: number,
  vitaminD: number,
  calcium: number,
  iron: number,
  potassium : number,
}

export interface Pricing {
  Taco: number,
  Burrito: number,
  HalfPlate: number,
  Plate: number,
  ALaCarte: number,
}

// access pricing using the ItemType enums
export const PricingTable: Pricing[] = [
  //tritip
  {
    Taco: 7,
    Burrito: 20,
    Plate: 40,
    HalfPlate: 22,
    ALaCarte: 34
  },
  //brisket
  {
    Taco: 5,
    Burrito: 16,
    Plate: 30,
    HalfPlate: 18,
    ALaCarte: 26
    
  },
  //burnt ends
  { 
    Taco: 7,
    Burrito: 18,
    Plate: 36,
    HalfPlate: 20,
    ALaCarte: 30
  },
  //pulled pork
  {
    Taco: 5,
    Burrito: 12,
    Plate: 24,
    HalfPlate: 14,
    ALaCarte: 22
  },
  //pulled pork birria
  {
    Taco: 5,
    Burrito: 14,
    Plate: 28,
    HalfPlate: 16,
    ALaCarte: 24
  },
  //filet mignon
  {
    Taco: 7,
    Burrito: 20,
    Plate: 38,
    HalfPlate: 22,
    ALaCarte: 34
  },
  //ranchero filet
  {
    Taco: 7,
    Burrito: 20,
    Plate: 38,
    HalfPlate: 22,
    ALaCarte: 34
  },
  //chicken breast
  {
    Taco: 5,
    Burrito: 12,
    Plate: 22,
    HalfPlate: 14,
    ALaCarte: 18
  },
  //prok belly
  {
    Taco: 5,
    Burrito: 14,
    Plate: 24,
    HalfPlate: 16,
    ALaCarte: 20
  },
  //beef lula
  {
    Taco: 5,
    Burrito: 14,
    Plate: 24,
    HalfPlate: 16,
    ALaCarte: 22
  },
  //tritip chili
  {
    Taco: 6,
    Burrito: 18,
    Plate: 30,
    HalfPlate: 18,
    ALaCarte: 26
  },
]

export const grilledMeatsData: Item[] = [
  {
    id: ItemIds.FiletMignon,
    image: FiletMignon,
    title: 'Filet Mignon',
    isVegan: false,
    pricePerPerson: 4,
    type: ItemType.Grilled,
    nutritionFacts:  {
      calories: 605,
      totalFat: 40,
      saturatedFat: 15.2,
      transfat: 0,
      polyUnsaturatedFat: 1.5,
      monoUnsaturatedFat: 16.3,
      cholesterol: 217.9,
      sodium: 122.7,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 58.7,
      vitaminD: 0.7,
      calcium: 42.7,
      iron: 3.7,
      potassium: 745.6,
    },
    pricing: PricingTable[ItemIds.FiletMignon],
    description: 'Center cut filets, lightly seasoned and grilled to medium/ medium rare. Tender and juicy'
  },
  {
    id: ItemIds.RancheroFilet,
    image: FiletMignon,
    title: 'Ranchero Filet',
    isVegan: false,
    pricePerPerson: 4,
    type: ItemType.Grilled,
    nutritionFacts:  {
      calories: 605,
      totalFat: 40,
      saturatedFat: 15.2,
      transfat: 0,
      polyUnsaturatedFat: 1.5,
      monoUnsaturatedFat: 16.3,
      cholesterol: 217.9,
      sodium: 122.7,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 58.7,
      vitaminD: 0.7,
      calcium: 42.7,
      iron: 3.7,
      potassium: 745.6,
    },
    pricing: PricingTable[ItemIds.RancheroFilet],
    description: 'Center cut filets, marinated in our zesty ranchero style'
  },
  {
    id: ItemIds.ChickenBreast,
    image: ChickenBreast,
    title: 'Marinated Chicken Breast',
    isVegan: false,
    pricePerPerson: 2,
    type: ItemType.Grilled,
    nutritionFacts: {
      calories: 382,
      totalFat: 8,
      saturatedFat: 2,
      transfat: 0,
      polyUnsaturatedFat: 1.3,
      monoUnsaturatedFat: 2.6,
      cholesterol: 195,
      sodium: 170,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 70,
      vitaminD: 0.2,
      calcium: 30,
      iron: 2.1,
      potassium: 610.3
    },
    pricing: PricingTable[ItemIds.ChickenBreast],
    description: 'Slightly spicy, marinated chicken breast grilled until tender.'
  },
  {
    id: ItemIds.PorkBelly,
    image: PorkBelly,
    title: 'Pork Belly',
    isVegan: false,
    pricePerPerson: 2,
    type: ItemType.Grilled,
    nutritionFacts: {
      calories: 664,
      totalFat: 48.7,
      saturatedFat: 17.6,
      transfat: 0.4,
      polyUnsaturatedFat: 8,
      monoUnsaturatedFat: 20.8,
      cholesterol: 192,
      sodium: 216,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 52,
      vitaminD: 0,
      calcium: 0,
      iron: 0,
      potassium: 52
    },
    pricing: PricingTable[ItemIds.PorkBelly],
    description: 'Fatty pork belly grilled to a crispy exterior, juicy interior and well-rendered melty fat throughout'
  },
];

export const smokedMeatsData: Item[] = [
  {
    id: ItemIds.Brisket,
    image: Brisket,
    title: 'Brisket',      
    isVegan: false,
    pricePerPerson: 4,
    type: ItemType.Smoked,
    nutritionFacts:  {
      calories: 655,
      totalFat: 42.7,
      saturatedFat: 16.5,
      transfat: 0,
      polyUnsaturatedFat: 1.5,
      monoUnsaturatedFat: 17.9,
      cholesterol: 240,
      sodium: 109.3,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 64,
      vitaminD: 0,
      calcium: 37.3,
      iron: 5.6,
      potassium: 525.9,
    },
    pricing: PricingTable[ItemIds.Brisket],
    description: 'Dry rubbed and slow-smoked for 12-16 hours until the meat melts in your mouth. Comes with delicious sliced brisket flat and point or burnt ends.'
  },
   {
    id: ItemIds.BrisketBurntEnds,
    image: BrisketBurntEnds,
    title: 'Brisket Burnt Ends',      
    isVegan: false,
    pricePerPerson: 4,
    type: ItemType.Smoked,
    nutritionFacts:  {
      calories: 655,
      totalFat: 42.7,
      saturatedFat: 16.5,
      transfat: 0,
      polyUnsaturatedFat: 1.5,
      monoUnsaturatedFat: 17.9,
      cholesterol: 240,
      sodium: 109.3,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 64,
      vitaminD: 0,
      calcium: 37.3,
      iron: 5.6,
      potassium: 525.9,
    },
    pricing: PricingTable[ItemIds.BrisketBurntEnds],
    description: 'Slow-smoked fatty point of the brisket, chopped into delectable cubes and sauced with our sweet and spicy craze sauce. '
  },
  {
    id: ItemIds.Tritip,
    image: Tritip,
    title: 'Tritip',
    isVegan: false,
    pricePerPerson: 5,
    type: ItemType.Smoked,
    nutritionFacts: {
      calories: 394.7,  
      totalFat: 21.5,
      saturatedFat: 8,
      transfat: 0,
      polyUnsaturatedFat: 1,
      monoUnsaturatedFat: 10.7,
      cholesterol: 154.8,
      sodium: 114.7,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 48,
      vitaminD: 0,
      calcium: 56,
      iron: 3.2,
      potassium: 709.5
    },
    pricing: PricingTable[ItemIds.Tritip],
    description: 'Dry rubbed and slow-smoked for 2-3 hours to produce a lightly-smoky, tender, mouth-watering slices of tritip.'
  },
  {
    id: ItemIds.PulledPork,
    image: PulledPork,
    title: 'Pulled Pork', 
    isVegan: false,
    pricePerPerson: 2,
    type: ItemType.Smoked,
    nutritionFacts: {
      calories: 421.3,
      totalFat: 29.3,
      saturatedFat: 9.9,
      transfat: 0.3,
      polyUnsaturatedFat: 3.7,
      monoUnsaturatedFat: 11.7,
      cholesterol: 141.3,
      sodium: 138.7,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 40,
      vitaminD: 0,
      calcium: 91,
      iron: 0,
      potassium: 720.8
    },
    pricing: PricingTable[ItemIds.PulledPork],
    description: 'Dry rubbed pork shoulder, slow-smoked for 12-13 hours. It is cooked until it\'s tender and pulls apart easier than a fluffy doughnut.'
  },
  {
    id: ItemIds.PulledPorkBirria,
    image: PulledPorkBirria,
    title: 'Pulled Pork Birria', 
    isVegan: false,
    pricePerPerson: 2,
    type: ItemType.Smoked,
    nutritionFacts: {
      calories: 421.3,
      totalFat: 29.3,
      saturatedFat: 9.9,
      transfat: 0.3,
      polyUnsaturatedFat: 3.7,
      monoUnsaturatedFat: 11.7,
      cholesterol: 141.3,
      sodium: 138.7,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 40,
      vitaminD: 0,
      calcium: 91,
      iron: 0,
      potassium: 720.8
    },
    pricing: PricingTable[ItemIds.PulledPorkBirria],
    description: 'Dry rubbed pork shoulder, slow-smoked for 12-13 hours. Then stewed in delicious birria consome.'
  },
];

export const sidesData: Item[] = [   
  {
      id: ItemIds.Tzatziki,
      image: Tzatziki,
      title: 'Tzatziki',
      isVegan: false,
      pricePerPerson: 1.5,
      type: ItemType.Side,
      nutritionFacts: {
        calories: 54,
        totalFat: 4.4,
        saturatedFat: 1.2,
        transfat: 0,
        polyUnsaturatedFat: 0.4,
        monoUnsaturatedFat: 2.6,
        cholesterol: 4.6,
        sodium: 110,
        totalCarbs: 2.6,
        dietaryFiber: 0.3,
        sugar: 2,
        protein: 1.5,
        vitaminD: 0,
        calcium: 64,
        iron: 0.2,
        potassium: 93.5
      },
      description: "A cool yogurt and cucumber based salad that goes great with almost any meat.",
  },
  {
      id: ItemIds.CabageSalad,
      image: CabbageSalad,
      title: 'Cabbage Salad',
      isVegan: true,
      pricePerPerson: 1,
      type: ItemType.Side,
      nutritionFacts: {
        calories: 40,
        totalFat: 0,
        saturatedFat: 0,
        transfat: 0,
        polyUnsaturatedFat: 0,
        monoUnsaturatedFat: 0,
        cholesterol: 0,
        sodium: 420,
        totalCarbs: 6,
        dietaryFiber: 3,
        sugar: 3,
        protein: 1,
        vitaminD: 0,
        calcium: 40,
        iron: 1,
        potassium: 0
      },
      description: 'A refreshing, slightly tart cabbage and carrot salad.',
  },
  {
    id: ItemIds.Hummus,
    title: 'Hummus',
    description: 'Creamy, mashed chicked peas that go well as a dip or side.',
    image: Hummus,
    isVegan: true,
    pricePerPerson: 1,
    type: ItemType.Side,
    nutritionFacts: {
      calories: 40,
        totalFat: 0,
        saturatedFat: 0,
        transfat: 0,
        polyUnsaturatedFat: 0,
        monoUnsaturatedFat: 0,
        cholesterol: 0,
        sodium: 420,
        totalCarbs: 6,
        dietaryFiber: 3,
        sugar: 3,
        protein: 1,
        vitaminD: 0,
        calcium: 40,
        iron: 1,
        potassium: 0
    }
  },
  {
    id: ItemIds.Rice,
    title: 'Rice',
    description: 'Round, fluffy white rice that is a fantastic accompaniment to everything on the menu.',
    image: Rice,
    isVegan: false,
    pricePerPerson: 1,
    type: ItemType.Side,
    nutritionFacts: {
      calories: 40,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 420,
      totalCarbs: 6,
      dietaryFiber: 3,
      sugar: 3,
      protein: 1,
      vitaminD: 0,
      calcium: 40,
      iron: 1,
      potassium: 0
    }
  },
  {
    id: ItemIds.StuffedMushrooms,
    title: 'Stuffed Mushrooms',
    description: 'Oven baked cream cheese and herb stuffed mushrooms.',
    image: StuffedMushrooms,
    isVegan: false,
    pricePerPerson: 1.5,
    type: ItemType.Side,
    nutritionFacts: {
      calories: 40,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 420,
      totalCarbs: 6,
      dietaryFiber: 3,
      sugar: 3,
      protein: 1,
      vitaminD: 0,
      calcium: 40,
      iron: 1,
      potassium: 0
    }
  },
  {
    id: ItemIds.StuffedJalapenos                                  ,
    title: 'Stuffed Jalapenos',
    description: 'Bacon wrapped cream cheese and herb stuffed jalapenos, baked in an oven.',
    image: StuffedJalapenos,
    isVegan: false,
    pricePerPerson: 1.5,
    type: ItemType.Side,
    nutritionFacts: {
      calories: 40,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 420,
      totalCarbs: 6,
      dietaryFiber: 3,
      sugar: 3,
      protein: 1,
      vitaminD: 0,
      calcium: 40,
      iron: 1,
      potassium: 0
    }
  },
  {
    id: ItemIds.PickledOnion,
    title: 'Pickled Onions',
    description: 'Our picked onions come zesty and spicy, a great topper to any of our meats.',
    image: PickledOnion,
    isVegan: true,
    pricePerPerson: 1,
    type: ItemType.Side,
    nutritionFacts: {
      calories: 40,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 420,
      totalCarbs: 6,
      dietaryFiber: 3,
      sugar: 3,
      protein: 1,
      vitaminD: 0,
      calcium: 40,
      iron: 1,
      potassium: 0
    }
  },
];

export const drinksDessertsData: Item[] = [
  {
    id: 1,
    image: Coke,
    title: 'Coke',
    isVegan: false,
    pricePerPerson: 30,
    type: ItemType.Other,
    nutritionFacts: 
    {
      calories: 140,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 45,
      totalCarbs: 39,
      dietaryFiber: 0,
      sugar: 39,
      protein: 0,
      vitaminD: 0,
      calcium: 0,
      iron: 0,
      potassium: 0
    },
    description: '',
  },
  {
    id: 2,
    image: Sprite,
    title: 'Sprite',
    isVegan: false,
    pricePerPerson: 30,
    type: ItemType.Other,
    nutritionFacts:        
    {
      calories: 140,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 65,
      totalCarbs: 38,
      dietaryFiber: 0,
      sugar: 39,
      protein: 0,
      vitaminD: 0,
      calcium: 0,
      iron: 0,
      potassium: 0
    },
    description: '',
  },      
  {
    id: 3,
    image: Water,
    title: 'Water', 
    isVegan: true,
    pricePerPerson: 30,
    type: ItemType.Other,
    nutritionFacts:        
    {
      calories: 0,
      totalFat: 0,
      saturatedFat: 0,
      transfat: 0,
      polyUnsaturatedFat: 0,
      monoUnsaturatedFat: 0,
      cholesterol: 0,
      sodium: 0,
      totalCarbs: 0,
      dietaryFiber: 0,
      sugar: 0,
      protein: 0,
      vitaminD: 0,
      calcium: 0,
      iron: 0,
      potassium: 0
    },
    description: '',
  },   
];

export const otherEntreesData: Item[] = [
  {
    id: ItemIds.SutDolma,
    image: SutDolma,
    title: 'Sut Dolma',
    isVegan: true,
    pricePerPerson: 2,
    type: ItemType.VeganEntree,
    nutritionFacts: 
    {
      calories: 318,
      totalFat: 4.5,
      saturatedFat: 0.7,
      transfat: 0,
      polyUnsaturatedFat: 2,
      monoUnsaturatedFat: 1.8,
      cholesterol: 12,
      sodium: 80,
      totalCarbs: 24,
      dietaryFiber: 0,
      sugar: 4,
      protein: 16,
      vitaminD: 0,
      calcium: 80,
      iron: 6,
      potassium: 400
    },
    description: 'Baked rice and herb stuffed sweet peppers.',
   },
  // {
  //   id: ItemIds.MedetteraneanDish,
  //   image: MedetteraneanDish,
  //   title: 'Mediterranean Vegetables & Chickpeas',
  //   isVegan: true,
  //   pricePerPerson: 2,
  //   type: ItemType.VeganEntree,
  //   nutritionFacts:        
  //   {
  //     calories: 250,
  //     totalFat: 6,
  //     saturatedFat: 0.7,
  //     transfat: 0,
  //     polyUnsaturatedFat: 0.5,
  //     monoUnsaturatedFat: 0.2,
  //     cholesterol: 46.2,
  //     sodium: 200,
  //     totalCarbs: 20,
  //     dietaryFiber: 3.5,
  //     sugar: 4,
  //     protein: 6,
  //     vitaminD: 0,
  //     calcium: 100,
  //     iron: 7,
  //     potassium: 450
  //   },
  //   description: 'Sateed mushrooms, chickpeas,  bell peppers, and zuchini. A rich and flavorful vegan dining option.',
  // },   
];
  
export const nutritionalData = {
  otherEntreesData: otherEntreesData,
  grilledMeatsData: grilledMeatsData,
  smokedMeatsData: smokedMeatsData,
  sidesData: sidesData,
  drinksDessertsData: drinksDessertsData,
}